export default __webpack_public_path__ + "static/media/produit_bbq.311562f5.jpg";